<div class="main-padding">
  <h3 class="header-bottom header-text1">{{ 'ACCOUNT_LIST.TITLE' | translate }}</h3>
  <div class="text-center">
    <div class="finish text-center">
      {{ 'ACCOUNT_RESEND.FINISH_TEXT' | translate }}
    </div>
    <div class="text-center">
      <div class="col-12">
        <div class="display finish2">
          <a (click)="back()" class="btn-grey">
            {{ 'ACCOUNT_RESEND.BACK_TO_ACCOUNT_LIST_BUTTON' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>     
</div>